import { EventBus } from '@/utils/eventBus'
export default {
  components: {},
  props: {
    screen: {
      type: Object,
      default: () => {
      }
    },
    message: {
      type: String,
      default: ''
    }
  },
  data() {
    let validateConfirmPassword = (rule, value, callback) => {
      if (value !== this.registerForm.Password) {
        callback(new Error('两次输入的密码不一致!'));
      } else {
        callback();
      }
    };
    return {
      msg: 'what',
      username:'',
      isLogin:'',
      url: {
        save: SZH.assets.api + '/Login/Logout',
        GetMsgRecord: SZH.assets.api + '/Custom/GetMsgRecord',
        SendCode: SZH.assets.api + '/Custom/SendCode',
        UpdateCustomPassword: SZH.assets.api + '/Custom/UpdateCustomPassword',
    },
      fullscreenLoading: false,
      menus: [],
      num:0,
      registerForm:{
        Password:'', // 登录密码
        RePassword:'', // 登录密码
        Phone:'', // 手机号
        VCode:'', // 短信验证码
      },
      rules: {

        Password: [
          {
            required: true,
            message: '请输入登录密码',
            trigger: 'blur'
          },
          {
            validator: validatePassword,
            trigger: 'blur'
          }
        ],
        RePassword: [
          {
            required: true,
            message: '请再次输入密码',
            trigger: 'blur'
          },
          {
            validator: validateConfirmPassword,
            trigger: 'blur'
          }
        ],
        Phone: [
          {
            required: true,
            message: '请输入手机号',
            trigger: 'blur'
          },
          {
            validator: validatePhone,
            trigger: 'blur'
          }
        ],
        VCode: [
          {
            required: true,
            message: '请输入短信验证码',
            trigger: 'blur'
          }
        ],

      },
      btnName:'获取验证码',
      setintIndex:null,
      sendVCodeTime:59,
      disBtn:false,
      dialogFormVisible:false,
    }
  },
  computed: {

  },
  created() {
    // 监听 'header-update' 事件，一旦触发就更新自己的数据
    EventBus.$on('header-update', (data) => {
      console.log('头部组件收到了新数据：', data);
      this.getNum();
    });

  },
  beforeDestroy() {
    EventBus.$off('header-update');
  },
  mounted() {
    this.username = localStorage.getItem('ms_username');
    this.isLogin = localStorage.getItem('ms_isLogin');
    this.getNum();
  },
  methods: {
    editPassword(){
      let self = this;
      self.dialogFormVisible = true;
      self.registerForm.Password = '';
      self.registerForm.Phone = localStorage.getItem('PhoneNo');
      self.registerForm.RePassword = '';
      self.registerForm.VCode = '';
    },
    getCode(){
      let self = this;
      if(!self.registerForm.Phone){
        self.$message.error('请输入手机号！');
        return
      }
      self.disBtn = true;
      //如果存在定时器不再调用接口
      if(self.setintIndex){
        return
      }
      //TODO
      self.sendVerifyCodeForRegisterFun();
      //调用接口成功调用下面的方法

    },
    sendVerifyCodeForRegisterFun(){
      let self = this;
      self.$http.post(self.url.SendCode, {
        Phone:self.registerForm.Phone
      }).then(result => {
        if (result.state == true) {
          self.$message.success('短信发送成功!');
          self.getReturnTime();
        } else {
          self.disBtn = false;
          self.$message.error(result.message);
        }
      }, () => {
        // 请求失败
        self.$message.error('注册失败，请检查您的网络是否可用。');
      });
    },
    getReturnTime(){
      this.btnName = '倒计时:'+this.sendVCodeTime+'s';
      this.setintIndex = setInterval(()=>{
        --this.sendVCodeTime;
        this.btnName = '倒计时:'+this.sendVCodeTime+'s';
        if(this.sendVCodeTime == 0){
          window.clearInterval(this.setintIndex);
          this.setintIndex = null;
          this.disBtn = false;
          this.btnName = '获取验证码';
          this.sendVCodeTime = 59;
        }
      },1000)
    },
    savePass(){
      let self = this;
      self.$refs['registerForm'].validate((valid) => {
        if (valid) {
          self.fullscreenLoading = true;
          self.$http.post(self.url.UpdateCustomPassword,  self.registerForm)
            .then(result => {
              if (result.state == true) { // 注册成功
                self.$message.success('修改成功!');
                self.dialogFormVisible = false
              } else {
                self.$message.error(result.message);
                // self.refreshCaptcha();
              }
              self.fullscreenLoading = false;
            }, () => {
              // 请求失败
              self.$message.error('注册失败，请检查您的网络是否可用。');
              self.fullscreenLoading = false;
            });
        } else {
          return false;
        }
      });
    },
    toLogin() {
      let self = this;
      self.$router.push({
        path: '/LoginTH'
      });
    },
    loginOut() {
      let self = this;
      self.fullscreenLoading = true;
      self.$http.post(self.url.save, self.form)
        .then(result => {
          if (result.state == true) { //
            self.$message.success('退出成功!');
            localStorage.removeItem('ms_isLogin');
            localStorage.removeItem('ms_username');
            EventBus.$emit('user-logout');
            self.$router.push({
              path: '/LoginTH'
            })
          } else {
            self.$message.error(result.message);
          }
          self.fullscreenLoading = false;
        }, () => {
          // 请求失败
          self.$message.error('退出失败，请检查您的网络是否可用。');
          self.fullscreenLoading = false;
        });
    },
    getNum() {
      let self = this;
      self.$http.post(self.url.GetMsgRecord, {})
        .then(result => {
          if (result.state == true) {
            let res = JSON.parse(result.data);
            self.num = res.privateCount;
          } else {
            self.num = 0;
          }
        }, () => {
          // 请求失败
          self.$message.error('退出失败，请检查您的网络是否可用。');
        });
    },
    turnTo(url) {
      this.$router.push({
        path: url,
      })
    },
  },
  watch: {
    message(newVal, oldVal) {
      console.log(`值从 ${oldVal} 变为 ${newVal}`);
      // 3. 在这里调用你想触发的方法
      this.getNum();
    }
  }
}




// WEBPACK FOOTER //
// ./src/components/HeaderB/HeaderB.js